import { render } from "./HeroModal.vue?vue&type=template&id=2b886806&scoped=true"
import script from "./HeroModal.vue?vue&type=script&lang=js"
export * from "./HeroModal.vue?vue&type=script&lang=js"

import "./HeroModal.vue?vue&type=style&index=0&id=2b886806&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b886806"]])

export default __exports__